export default "__VITE_ASSET__CERaGrfG__"